<template>
  <router-view />
  <AiAssistant v-if="showAssistant" />
  <ConfirmDialog ref="confirmDialogRef" />
</template>

<script>
import { computed, ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import AiAssistant from './components/AiAssistant.vue'
import ConfirmDialog, { useConfirm } from './components/ConfirmDialog.vue'
import api from './api'
import './styles/design-system.css'

export default {
  name: 'App',
  components: { AiAssistant, ConfirmDialog },
  setup() {
    const route = useRoute()
    const confirmDialogRef = ref(null)
    const visibleMenuPaths = ref(new Set())
    const menusLoaded = ref(false)

    const fetchVisibleMenus = async () => {
      if (!localStorage.getItem('token')) {
        visibleMenuPaths.value = new Set()
        menusLoaded.value = true
        return
      }
      try {
        const res = await api.get('/menus/')
        const paths = new Set((res.data || []).map(m => m.path))
        visibleMenuPaths.value = paths
      } catch (e) {
        console.error('fetch visible menus error:', e)
        visibleMenuPaths.value = new Set()
      }
      menusLoaded.value = true
    }

    const showAssistant = computed(() => {
      // 登录/注册页面不显示 AI 助手；后台管理系统（/admin）不显示；菜单未加载完成前也不显示，避免闪烁
      const hiddenRoutes = ['/login', '/register', '/forgot-password']
      return !hiddenRoutes.includes(route.path) && !route.path.startsWith('/admin') && localStorage.getItem('token') && menusLoaded.value && visibleMenuPaths.value.has('__ai_assistant__')
    })

    onMounted(() => {
      // 全局挂载自定义确认框，供其他组件通过 confirm() 调用
      if (confirmDialogRef.value) {
        const { show } = confirmDialogRef.value
        window.$dwConfirm = show
      }
      fetchVisibleMenus()
    })

    // localStorage 不是响应式的，无法直接 watch。
    // 通过监听路由变化，在登录/登出（token 变化）后重新拉取可见模块，避免权限状态陈旧
    let lastToken = localStorage.getItem('token')
    watch(() => route.path, () => {
      const current = localStorage.getItem('token')
      if (current !== lastToken) {
        lastToken = current
        fetchVisibleMenus()
      }
    })

    return { showAssistant, confirmDialogRef }
  }
}

export { useConfirm }
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8f9fa;
}

#app {
  height: 100vh;
}
</style>
